import type { BoxDefInput } from '../schemas/rooms';

/**
 * FTUE starter boxes (docs/design/content-items.md §G, content-schemas §3.7). Each box carries one of Granny's
 * sticky notes. Box 5's welcome letter IS chapter 1 (dlg_ch1); it opens only after Dusting level 1 (T06).
 * Sprites follow docs/art/asset-list.md: shared `obj_box_ftue` (tinted per box) and `obj_box_grandma` for box 5.
 */
export const STARTER_BOXES = [
  {
    id: 'box_01_sleep',
    nameKey: 'ui.box.box_01_sleep.name',
    noteKey: 'ui.box.box_01_sleep.note',
    order: 1,
    contents: [
      { type: 'item', itemId: 'fur_bed_pine', qty: 1 },
      { type: 'item', itemId: 'fur_nightstand_pine', qty: 1 },
    ],
    material: 'box',
    sprite: 'obj_box_ftue',
  },
  {
    id: 'box_02_work',
    nameKey: 'ui.box.box_02_work.name',
    noteKey: 'ui.box.box_02_work.note',
    order: 2,
    contents: [
      { type: 'item', itemId: 'fur_desk_pine', qty: 1 },
      { type: 'item', itemId: 'fur_chair_pine', qty: 1 },
    ],
    material: 'box',
    sprite: 'obj_box_ftue',
  },
  {
    id: 'box_03_books',
    nameKey: 'ui.box.box_03_books.name',
    noteKey: 'ui.box.box_03_books.note',
    order: 3,
    contents: [
      { type: 'item', itemId: 'fur_bookshelf', qty: 1 },
      { type: 'item', itemId: 'dec_book_stack', qty: 2 },
    ],
    material: 'box',
    sprite: 'obj_box_ftue',
  },
  {
    id: 'box_04_kitchen',
    nameKey: 'ui.box.box_04_kitchen.name',
    noteKey: 'ui.box.box_04_kitchen.note',
    order: 4,
    contents: [{ type: 'item', itemId: 'fur_kitchen_counter', qty: 1 }],
    material: 'box',
    sprite: 'obj_box_ftue',
  },
  {
    id: 'box_05_granny',
    nameKey: 'ui.box.box_05_granny.name',
    noteKey: 'ui.box.box_05_granny.note',
    order: 5,
    contents: [
      { type: 'chapter', chapterId: 'ch1' },
      { type: 'item', itemId: 'dec_herb_pots', qty: 1 },
    ],
    requiresMiniGame: { miniGameId: 'mg_dusting', level: 1 },
    material: 'box',
    sprite: 'obj_box_grandma',
  },
  {
    id: 'box_06_shop',
    nameKey: 'ui.box.box_06_shop.name',
    noteKey: 'ui.box.box_06_shop.note',
    order: 6,
    contents: [
      { type: 'item', itemId: 'prod_instant_noodle', qty: 4 },
      { type: 'item', itemId: 'prod_canned_coffee', qty: 4 },
      { type: 'item', itemId: 'prod_cookie_box', qty: 4 },
    ],
    material: 'box',
    sprite: 'obj_box_ftue',
  },
] as const satisfies readonly BoxDefInput[];
